import { ProjectStatus } from '../generated/graphql'
import { capitalCase } from 'change-case'

export const formatStatus = (status: ProjectStatus): string => {
  return capitalCase(status)
}
